import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'

import Axios from '@components/Axios'
import Card from '@components/Card'
import Modal from '@components/Modal'
import Button from '@components/Button'

import FormGroup from './components/FormGroup'

const AddEdit = props => {
  let { close, item = {}, updateList } = props

  const schema = {
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('REQUIRED'),
    })
  }

  const footer = submit => {
    return <Button onClick={submit}>ENTERPRISETYPE_ADD_CARD_SEND</Button>
  }

  const onSuccess = () => {
    close()
    updateList()
  }

  const add = ({ handleSubmit, ...formik }) => {
    return (
      <Card footer={() => footer(handleSubmit)}>
        <FormGroup {...props} formik={formik} />
      </Card>
    )
  }

  const edit = ({ handleSubmit, ...formik }) => {
    return (
      <Modal
        close={close}
        open={!!item?._id}
        title="CONSTRUCTION_SYSTEM_EDIT_MODAL_TILE"
        actions={() => actions({ handleSubmit })}
      >
        <FormGroup {...props} formik={formik} />
      </Modal>
    )
  }

  const actions = ({ handleSubmit }) => {
    return (
      <div className="actions">
        <Button color="secondary" onClick={close}>
          ENTERPRISETYPE_BUTTON_CLOSE
        </Button>
        <Button onClick={handleSubmit}>CONSTRUCTION_SYSTEM_ADD_CARD_SEND</Button>
      </div>
    )
  }

  let params = {}
  if (item?._id) {
    params = {
      method: 'put',
      others: item._id
    }
  } else {
    params = {
      method: 'post'
    }
  }

  const onSubmit = ({ values, submit, resetForm }) => {
    submit({ params: values })
    resetForm()
  }

  return (
    <div className="AddEdit">
      <Axios api="constructionSystem" {...params} onSuccess={onSuccess}>
        {({ submit }) => (
          <Formik
            {...schema}
            onSubmit={(values, event) => onSubmit({ ...event, values, submit })}
          >
            {formik => (item?._id ? edit(formik) : add(formik))}
          </Formik>
        )}
      </Axios>
    </div>
  )
}

export default AddEdit

